import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { setWorkExperience, fetchWorkExperienceQualifications } from './action';
import { isServer } from 'utils';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [setWorkExperience]: {
    next: (state: State.ExemptionWorkExperience, action: any): State.ExemptionWorkExperience => ({
      ...state,
      exempReference: action.payload,
      exemptReferenceFetched: true,
      exemptReferenceFrontloadRequest: isServer,
    }),
  },
  [fetchWorkExperienceQualifications]: {
    next: (state: State.ExemptionWorkExperience, action: any): State.ExemptionWorkExperience => ({
      ...state,
      allWorkExperienceReference: action.payload.getExemption,
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
